export default class Loader {
  constructor(parent) {
    this.parent = parent;
    this.el = parent.el.querySelector('.configurator--content-loader');
  }

  show() {
    this.el?.classList?.remove('hide');
  }

  hide() {
    this.el?.classList?.add('hide');
  }
}